import React from 'react';
import { connect } from 'react-redux';
import StoredLayout from 'layouts/StoredLayout';
import { Link } from 'react-router-dom';

import LoadingSpinner from 'cyder/loadingSpinner/LoadingSpinner';
import { membershipRenewalDetailAnalytics } from 'actions/analytics/memberAnalyticsAction';
import ReactTable from 'react-table';
import matchSorter from 'match-sorter';

class MembershipRenewalDetailsList extends React.Component {
    constructor(props) {
        super(props);
        this.load = this.load.bind(this);
        this.state = {
            refreshState: new Date().getTime(),
        };
    }
    load() {
        this.props.load(this.props.renewalStatusId).then(res => {
            this.setState({
                data: res.data,
            });
            this.props.loadDataCb(res.data);
        });
    }
    componentDidMount() {
        this.load();
    }
    render() {
        const columns = [
            {
                Header: 'ID',
                accessor: 'id',
                maxWidth: 75,
                filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['id'] }),
                filterAll: true,
                style: { whiteSpace: 'unset' },
                Cell: props => {
                    return <Link to={'/staff/company/' + props.value}>{props.value}</Link>;
                },
            },
            {
                Header: 'Company',
                accessor: 'name',
                filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['name'] }),
                filterAll: true,
                style: { whiteSpace: 'unset' },
            },
        ];

        return this.state.data == null ? (
            <LoadingSpinner />
        ) : (
            <React.Fragment>
                <div className="table-responsive">
                    <ReactTable
                        columns={columns}
                        filterable={true}
                        minRows={0}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        data={this.state.data}
                    />
                </div>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        load: renewalStatusId => {
            return dispatch(membershipRenewalDetailAnalytics(renewalStatusId));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(MembershipRenewalDetailsList));
